export const retailers = [
  {
    path: "/retailers",
    name: "retailers",
    label: "Retailers",
    icon: "shopping-bag",
    component: () => import("@/views/retailers/RetailersList.vue"),
    meta: {
      title: "Retailers",
      ability: { action: "read", subject: "Retailer" },
    },
  },
  {
    path: "/retailers/:id",
    name: "retailers.index",
    component: () => import("@/views/retailers/RetailersDetails.vue"),
    meta: {
      title: "Retailers Details",
      ability: { action: "Update", subject: "Retailer" },
    },
  },
];
